<template>
  <hm-content title="">
    <div class="table-panel">
      <el-button type="primary" size="small" @click="add"
        >添加机器人
      </el-button>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        stripe
        size="small"
        border
        ref="table"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="机器人昵称"
          prop="robotNickName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="robotWxid"
          label="微信号"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="onlineState"
          label="在线/离线"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.onlineState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.onlineState === "yes" ? "在线" : "离线" }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="keAiMaoRobotLastMessageAcceptanceTime"
          label="最后接收消息时间"
        >
        <template slot-scope="scope">
          <div v-if="scope.row.enabledState === 'yes'">
            {{scope.row.keAiMaoRobotLastMessageAcceptanceTime}}
          </div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="禁/启用"
        >
          <template slot-scope="scope">
            <div
              :class="scope.row.enabledState === 'yes' ? 'success' : 'danger'"
            >
              {{ scope.row.enabledState === "yes" ? "启用" : "禁用" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="accountNum"
          label="好友数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="groupNum"
          label="群数量"
        ></el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="230"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                type="text"
                size="small"
                :class="scope.row.enabledState === 'yes' ? 'danger' : 'success'"
                @click="editWx(scope.row)"
              >
                {{ scope.row.enabledState === "yes" ? "禁用" : "启用" }}
              </el-button>
              <el-button type="text" size="small" @click="remove(scope.row)">
                删除
              </el-button>
              <el-button type="text" size="small" @click="wxlist(scope.row)">
                微信列表
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="synchronous(scope.row)"
                v-if="scope.row.enabledState === 'yes'"
              >
                同步
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="1550px"
    >
      <div v-if="type === 'add'">
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="机器人微信号：" prop="robotWxid">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              style="width:270px"
              v-model.trim="ruleForm.robotWxid"
              placeholder="请输入机器人微信号"
            ></el-input>
            <el-button
              type="primary"
              size="small"
              :disabled="ruleForm.robotWxid === ''"
              @click="search"
              >匹 配</el-button
            >
          </el-form-item>
          <el-form-item label="匹配结果：" prop="groupInfoModelList">
            <div class="flex flex-between">
              <div>昵称:{{ robotNickName }}</div>
              <div>群数量:{{ groupNum }}个</div>
            </div>
            <el-table
              :data="ruleForm.groupInfoModelList"
              style="width: 100%"
              stripe
              size="small"
              border
              ref="table"
              height="500"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="群名称"
                prop="nickname"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxid"
                label="群ID"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="mobile"
                label="关联商户"
                width="280"
              >
                <template slot-scope="scope">
                  <el-select
                    size="small"
                    clearable
                    filterable
                    v-model="scope.row.storeCode"
                    class="mr10"
                    placeholder="请选择关联商户"
                    @change="storeChange(scope.row.storeCode, scope.$index)"
                  >
                    <el-option
                      v-for="(item, i) in scope.row.storeList"
                      :key="i"
                      :label="item.storeName"
                      :value="item.storeCode"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="mobile"
                label="关联门店"
                width="280"
              >
                <template slot-scope="scope">
                  <el-select
                    size="small"
                    clearable
                    style="width:200px"
                    v-model="scope.row.shopIds"
                    class="mr10"
                    placeholder="请选择关联门店"
                    filterable
                    @change="changeSelect(scope.row.shopIds, scope.$index)"
                    @remove-tag="removeTag(scope.row.shopIds, scope.$index)"
                    multiple
                  >
                    <el-option
                      v-if="scope.row.shopList.length"
                      label="全选"
                      value="all"
                      @click.native="selectAll(scope.$index)"
                    ></el-option>
                    <el-option
                      v-for="(item, i) in scope.row.shopList"
                      :key="i"
                      :label="item.shopName"
                      :value="item.shopId"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="mobile"
                label="关联品牌"
                width="280"
              >
                <template slot-scope="scope">
                  <el-select
                    filterable
                    clearable
                    multiple
                    size="small"
                    class="mr10 "
                    v-model="scope.row.brandIds"
                    placeholder="请选择关联品牌"
                  >
                    <el-option
                      :label="v.brandName"
                      :value="v.hemiaoBrandId"
                      v-for="(v, i) in scope.row.allBrandList"
                      :key="i"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button size="small" type="primary" @click="addWxRobot('ruleForm')"
            >确 认</el-button
          >
          <el-button size="small" @click="dialogVisible = false"
            >取消</el-button
          >
        </span>
      </div>
      <div v-if="type === 'vxlist'" class="flex flex-between">
        <div class="flex-1 mr10">
          <div class="title">
            好友
          </div>
          <el-table
            :data="accountList"
            style="width:100%"
            stripe
            size="small"
            border
            ref="table"
            height="500"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="index => index + (currentPageAccount - 1) * 10 + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="名称"
              prop="nickName"
              :filters="filterAccount"
              :filter-method="filterAccountTag"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxid"
              label="微信号"
            ></el-table-column>

            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button type="text" size="small" @click="msglog">
                    消息日志
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="accountTotal"
              @current-change="pagingAccount"
              @size-change="handleSizeChangeAccount"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageAccount"
            ></el-pagination>
          </div>
        </div>
        <div class="flex-1 ">
          <div class="title">
            群
          </div>
          <el-table
            :data="groupList"
            style="width: 100%"
            stripe
            size="small"
            border
            ref="table"
            height="500"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="名称"
              prop="nickname"
              :filters="filterNickname"
              :filter-method="filterTag"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxid"
              label="群ID"
            ></el-table-column>

            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button type="text" size="small" @click="msglog">
                    消息日志
                  </el-button>
                  <!-- <el-button type="text" size="small" @click="edit">
                    编辑
                  </el-button> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog
          width="50%"
          :title="titleAppend"
          :visible.sync="innerVisible"
          append-to-body
        >
          <div v-if="typeAppend === 'msglog'">
            <div class="mb10" style="color:#000;fontSize:16px">
              <span class="mr20">九江爱因宝1群</span>
              群ID:456123981655616
            </div>
            <div style="height:600px">
              <el-scrollbar style="height:100%" class="page-component__scroll">
                <el-timeline>
                  <el-timeline-item timestamp="2018/4/12" placement="top">
                    <el-card>
                      <p>昵称 2018/4/12 20:46</p>
                      <h4>XXXXXXXXXXXXXXXXXXX</h4>
                    </el-card>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2018/4/12" placement="top">
                    <el-card class="text-right">
                      <p>昵称 2018/4/12 20:46</p>
                      <h4>XXXXXXXXXXXXXXXXXXX</h4>
                    </el-card>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2018/4/12" placement="top">
                    <el-card>
                      <p>昵称 2018/4/12 20:46</p>
                      <h4>XXXXXXXXXXXXXXXXXXX</h4>
                    </el-card>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2018/4/12" placement="top">
                    <el-card class="text-right">
                      <p>昵称 2018/4/12 20:46</p>
                      <h4>XXXXXXXXXXXXXXXXXXX</h4>
                    </el-card>
                  </el-timeline-item>
                  <el-timeline-item timestamp="2018/4/12" placement="top">
                    <el-card class="text-right">
                      <p>昵称 2018/4/12 20:46</p>
                      <h4>XXXXXXXXXXXXXXXXXXX</h4>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </el-scrollbar>
            </div>
          </div>
          <div v-if="typeAppend === 'edit'">
            <el-form
              ref="ruleForms"
              :model="ruleForms"
              :rules="groupRules"
              label-width="150px"
            >
              <el-form-item label="群名称："> </el-form-item>
              <el-form-item label="群ID："> </el-form-item>
              <el-form-item label="管理机器人名称："> </el-form-item>
              <el-form-item label="群成员数："> </el-form-item>
              <el-form-item label="关联商户/门店：" prop="storeCodes">
                <el-select
                  size="small"
                  clearable
                  filterable
                  v-model="ruleForm.storeCode"
                  class="mr10"
                  placeholder="请选择关联商户"
                  @change="storeChange"
                >
                  <el-option
                    v-for="(item, i) in storeList"
                    :key="i"
                    :label="item.storeName"
                    :value="item.storeCode"
                  ></el-option>
                </el-select>
                <el-select
                  size="small"
                  clearable
                  multiple
                  v-model="ruleForm.shopIds"
                  class="mr10"
                  placeholder="请选择关联门店"
                  filterable
                >
                  <el-option
                    v-for="(item, i) in shopList"
                    :key="i"
                    :label="item.shopName"
                    :value="item.shopId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="关联品牌：" prop="brandIds">
                <el-select
                  size="small"
                  clearable
                  v-model="ruleForm.brandIds"
                  class="mr10"
                  placeholder="请选择关联品牌"
                  filterable
                  multiple
                >
                  <el-option
                    :label="v.brandName"
                    :value="v.hemiaoBrandId"
                    v-for="(v, i) in allBrandList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer flex flex-center">
              <el-button size="small" type="primary">确 认</el-button>
              <el-button size="small" @click="innerVisible = false"
                >取消</el-button
              >
            </span>
          </div>
        </el-dialog>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ruleForms: {
        storeCode: "",
        shopIds: [],
        brandIds: []
      },
      groupRules: {},
      ruleForm: {
        robotWxid: "",
        groupInfoModelList: []
      },
      rules: {
        robotWxid: {
          required: true,
          message: "请输入机器人微信号",
          trigger: "blur"
        },
        groupInfoModelList: {
          required: true,
          message: "请输入匹配机器人微信号",
          trigger: "blur"
        }
      },
      robotNickName: "",
      groupNum: 0,
      typeAppend: "",
      titleAppend: "",
      innerVisible: false,
      groupList: [],
      type: "",

      copyRobotWxid: "",
      title: "",
      list: [],
      dialogVisible: false,
      accountList: [],
      accountTotal: 0,
      currentPageAccount: 1,
      pageSizeAccount: 10,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      storeList: [],
      shopList: [],
      allBrandList: [],
      row: {},
      filterNickname: [],
      filterAccount: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryStoreList();
    this.queryBrandList();
    this.queryList();
  },
  methods: {
    removeTag(val, i) {
      if (val === "all") {
        this.ruleForm.groupInfoModelList[i].shopIds = [];
      }
    },
    changeSelect(val, i) {
      if (
        !val.includes("all") &&
        val.length === this.ruleForm.groupInfoModelList[i].shopList.length
      ) {
        this.ruleForm.groupInfoModelList[i].shopIds.unshift("all");
      } else if (
        val.includes("all") &&
        val.length - 1 < this.ruleForm.groupInfoModelList[i].shopList.length
      ) {
        this.ruleForm.groupInfoModelList[
          i
        ].shopIds = this.ruleForm.groupInfoModelList[i].shopIds.filter(item => {
          return item !== "all";
        });
      }
    },
    selectAll(i) {
      if (
        this.ruleForm.groupInfoModelList[i].shopIds.length <
        this.ruleForm.groupInfoModelList[i].shopList.length
      ) {
        this.ruleForm.groupInfoModelList[i].shopIds = [];
        this.ruleForm.groupInfoModelList[i].shopList.map(item => {
          this.ruleForm.groupInfoModelList[i].shopIds.push(item.shopId);
        });
        this.ruleForm.groupInfoModelList[i].shopIds.unshift("all");
      } else {
        this.ruleForm.groupInfoModelList[i].shopIds = [];
      }
    },
    async synchronous(row) {
      const { code } = await this.$store.dispatch("synchroGroup", row);
      if (code === "0") {
        this.$message({
          message: "同步成功",
          type: "success"
        });
        this.queryList();
      }
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForms.resetFields();
        this.robotNickName = "";
        this.groupNum = 0;
      }, 0);
    },
    filterTag(value, row) {
      return row.nickname === value;
    },
    filterAccountTag(value, row) {
      return row.nickName === value;
    },
    async editWx(row) {
      let params = JSON.parse(JSON.stringify(row));
      params.operationType = "disable";
      params.enabledState = params.enabledState === "yes" ? "no" : "yes";
      const { code } = await this.$store.dispatch("editWxRobotInfo", params);
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });

        this.queryList();
      }
    },
    async addWxRobot(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = this.ruleForm;
        params.robotNickName = this.robotNickName;
        const { code } = await this.$store.dispatch("addWxRobotInfo", params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogVisible = false;
          this.resetRuleForm();
          this.queryList();
        }
      }
    },
    async search() {
      this.copyRobotWxid = JSON.parse(JSON.stringify(this.ruleForm.robotWxid));
      const { result } = await this.$store.dispatch("matchingRobot", {
        robotWxid: this.ruleForm.robotWxid
      });

      const { robotNickName, groupInfoList, groupNum } = result;
      this.robotNickName = robotNickName;
      groupInfoList.forEach(v => {
        v.shopList = [];
        v.storeList = JSON.parse(JSON.stringify(this.storeList));
        v.allBrandList = JSON.parse(JSON.stringify(this.allBrandList));
      });
      this.ruleForm.groupInfoModelList = groupInfoList;
      this.groupNum = groupNum;
    },
    storeChange(val, i) {
      this.ruleForm.groupInfoModelList[i].shopIds = [];

      this.queryShopList(val, i);
    },
    async queryShopList(val, i) {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: val
      };
      const { result } = await this.$store.dispatch(
        "queryStoreShopInfoList",
        params
      );
      this.ruleForm.groupInfoModelList[i].shopList = result.records;
      this.ruleForm.groupInfoModelList = [...this.ruleForm.groupInfoModelList];
    },
    async queryBrandList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const { result } = await this.$store.dispatch(
        "queryHemiaoBrandList",
        params
      );
      this.allBrandList = result.records;
    },
    async queryStoreList() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.storeList = result || [];
    },
    edit() {
      this.titleAppend = "群编辑";
      this.typeAppend = "edit";
      this.innerVisible = true;
    },
    msglog() {
      this.titleAppend = "消息日志";
      this.typeAppend = "msglog";
      this.innerVisible = true;
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryWxRobotInfoList",
        searchCondition
      );
      this.list = result.records;
      this.total = result.total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingAccount(page) {
      this.currentPageAccount = page;
      this.queryAccountInfoList();
    },
    handleSizeChangeAccount(size) {
      this.currentPageAccount = 1;
      this.pageSizeAccount = size;
      this.queryAccountInfoList();
    },
    add() {
      this.title = "添加机器人";
      this.type = "add";
      this.dialogVisible = true;
    },
    wxlist(row) {
      this.row = row;
      this.title = "微信列表";
      this.type = "vxlist";
      this.dialogVisible = true;
      this.queryAccountInfoList();
      this.queryGroupInfoList();
    },
    async queryGroupInfoList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        robotId: this.row.id
      };
      const { result } = await this.$store.dispatch(
        "queryGroupInfoList",
        params
      );
      this.groupList = result.records;
      this.groupList.forEach(v => {
        this.filterNickname.push({ text: v.nickname, value: v.nickname });
      });

      // this.total = result.total;
    },
    async queryAccountInfoList() {
      let params = {
        pageNo: this.currentPageAccount,
        pageSize: this.pageSizeAccount,
        robotId: this.row.id
      };
      const { result } = await this.$store.dispatch(
        "queryAccountInfoList",
        params
      );
      this.accountList = result.records;
      this.filterAccount = [];
      this.accountList.forEach(v => {
        this.filterAccount.push({ text: v.nickName, value: v.nickName });
      });
      this.accountTotal = result.total;
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = JSON.parse(JSON.stringify(row));
        params.operationType = "del";
        this.$store.dispatch("editWxRobotInfo", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 5px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>
